import { useMediaQuery } from '@conexasaude/conexa-hero'

interface BreakpointProps {
  isPhone: boolean
  isTablet: boolean
  isSmallDesktop: boolean
  isDesktop: boolean
}

const devices = {
  phone: {
    max: 639,
  },
  tablet: {
    min: 640,
    max: 1023,
  },
  smallDesktop: {
    min: 1024,
    max: 1087,
  },
  desktop: {
    min: 1088,
  },
}

export default function useWindowSize(): BreakpointProps {
  const isPhone = useMediaQuery(`(max-width: ${devices.phone.max}px)`)
  const isTablet = useMediaQuery(
    `(min-width: ${devices.tablet.min}px) and (max-width: ${devices.tablet.max}px)`,
  )
  const isSmallDesktop = useMediaQuery(
    `(min-width: ${devices.smallDesktop.min}px) and (max-width: ${devices.smallDesktop.max}px)`,
  )
  const isDesktop = useMediaQuery(`(min-width: ${devices.desktop.min}px)`, true)

  return { isPhone, isTablet, isSmallDesktop, isDesktop }
}
